import { css } from 'styled-components';
import scalingSize from '$utils/scalingSize';

const dynamicPadding = css`
  ${scalingSize('padding-top', 28, 64, 1.166666667)}
  ${scalingSize('padding-bottom', 28, 64, 1.166666667)}
`;

export default dynamicPadding;
